import { Component, Injector, Input } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AllocationSheetStatus } from '@shared/service-proxies/service-proxies';

@Component({
    selector: 'app-status-details',
    templateUrl: './status-details.component.html',
    styleUrls: ['./status-details.component.scss'],
})
export class StatusDetailsComponent extends AppComponentBase {
    @Input() status: number;
    @Input() date?: string;
    @Input() reason?: string;
    @Input() whoChanged?: string;
    @Input() standaloneMode?: boolean = false;
    @Input() showReason?: boolean = false;

    allocationSheetStatus = AllocationSheetStatus;
    redStatuses = [
        this.allocationSheetStatus.RejectedByForeman,
        this.allocationSheetStatus.RejectedByProjectAdmin,
        this.allocationSheetStatus.CancelledAfterForemanRejected,
        this.allocationSheetStatus.CancelledAfterProjectAdminRejected,
    ];
    greenStatuses = [
        this.allocationSheetStatus.NotSubmitted,
        this.allocationSheetStatus.SubmittedBySupervisor,
        this.allocationSheetStatus.SignedOffByForeman,
        this.allocationSheetStatus.ApprovedByProjectAdmin,
    ];

    constructor(
        injector: Injector
    ) {
        super(injector);
    }

    getClass() {
        return {
            'status-container__red': this.redStatuses.some(
                (status) => status === this.status
            ),
            'status-container__green': this.greenStatuses.some(
                (status) => status === this.status
            ),
            'status-container__standalone': this.standaloneMode,
        };
    }
}
